import { QueryKey } from '../../constants/index';

/**
 * Every data room mutation invalidates all of these.
 *
 * One named array rather than a list per hook: the detail query is easy to forget, and a stale
 * detail after a rename is the kind of bug that only shows up once someone reopens the modal.
 */
export const SPACE_INVALIDATION_KEYS: QueryKey[] = [
  QueryKey.DATA_ROOM,
  // Home and the sidebar read their own endpoints; without these a new, renamed or deleted room
  // would only show once their cache went stale.
  QueryKey.GET_SPACES_HOME,
  QueryKey.GET_SPACES_NAVIGATION,
];
